export const STREAM_SOURCE_OPERATION_STATUS = 'check-status';
export const STREAM_SOURCE_OPERATION_LIST_RECORDINGS = 'list-recordings';
export const STREAM_SOURCE_OPERATION_DOWNLOAD_RECORDING = 'download-recording';

export const DISK_STATUS_OK = 'OK';
export const DISK_STATUS_DISCONNECTED = 'disconnected';